import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TextField } from "@mui/material";
import React from "react";
import TableSortLabel from "@mui/material/TableSortLabel";
export const ServiceDistributionEdit = ({ headers, rows, countries, componentList, isEditable,rowCount,currentPage }) => {
    
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('countryName');
    const createSortHandler = (property) => (event) => {
        setOrder(order=='asc' ? 'desc' : 'asc');
        setOrderBy(property);
      };
      function descendingComparator(a, b, orderBy1,orderBy2) {
        if (b[orderBy1] < a[orderBy1] ) {
          return -1;
        }
        if (b[orderBy1] > a[orderBy1] ) {
            return 1;
        }
        if(b[orderBy2] < a[orderBy2])  {
               return -1;
        }
        if(b[orderBy2] > a[orderBy2])  {
            return 1;
     }
        return 0;
      }
      
      function getComparator(order, orderBy1,orderBy2) {
        return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy1,orderBy2)
          : (a, b) => -descendingComparator(a, b, orderBy1,orderBy2);
      }
      
      function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
            return order;
          }
          return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
      }
    
    
    
    
    
    
    
    function getUtilValue(countryId, productId, productVariationId, componentId) {
        const obj = rows.find((x) => x.countryId === countryId && x.productId === productId && x.productVariationId === productVariationId && x.componentId === componentId);
        const component = componentList.find((x) => x.id === componentId);
        let isComponentAutoSelect = false;
        if (component) {
            isComponentAutoSelect = component.autoSelect;
        }
        if (isEditable && isComponentAutoSelect) {
            return (<TextField name={obj.id}
                
                className="serviceDistributionInput"
                value={obj.utilizationPercent}
                size="small" required />)
        } else {
            return Number(obj.utilizationPercent.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits:2 });
        }                               
    }
    countries=countries.sort((a, b) => a.countryName.localeCompare(b.countryName));
    return (
            <TableContainer component={Paper}>
                <Table id="ComponentTable1" sx={{ minWidth: 400 }} aria-label="customized table" >
                    <TableHead>
                        <TableRow>
                            <TableCell>Country
                                 <TableSortLabel
                                        active={orderBy === 'countryName'}
                                        direction={orderBy === 'countryName'? order : 'desc'}
                                        onClick={createSortHandler('countryName')}>
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>Head Count
                                <TableSortLabel
                                    active={orderBy === 'headcount'}
                                    direction={orderBy === 'headcount' ? order : 'desc'}
                                    onClick={createSortHandler('headcount')}>      
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Product Variation</TableCell>
                            {headers.map((header) => (
                                <TableCell key={header.componentId}>{header.componentName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(rowCount > 0 ? stableSort(countries, getComparator(order, orderBy)).slice(
                                (Number(currentPage) - 1) * rowCount,
                                (Number(currentPage) - 1) * rowCount + rowCount,) : countries)
                        .map((row) => (
                            <TableRow key={row.id}>
                                <TableCell sx={{fontWeight:600}}>{row.countryName}</TableCell>
                                <TableCell>{row.headcount}</TableCell>
                                <TableCell>{row.productName}</TableCell>
                                <TableCell>{row.productVariationName}</TableCell>
                                {headers.map((cell) => (
                                    <TableCell key={cell.id}>{
                                        getUtilValue(row.countryId, row.productId, row.productVariationId, cell.componentId)
                                    }</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    );
};
export default ServiceDistributionEdit;